<script>
    import Modal from './Modal.svelte';
	import { modal } from './stores.js';
    import PopupNewSubscription from './PopupNewSubscription.svelte';
    export let addNewSubscription;
</script>

<Modal show={$modal}>
    <PopupNewSubscription addNewSubscription={addNewSubscription} />
</Modal>